const EmployeeData = {
  shift1: [
    { name: "Brooklyn Simmons", role: "Admin" },
    { name: "Dianne Russell", role: "Cashier" },
    { name: "Esther Howard", role: "Chef" },
    { name: "Jenny Wilson", role: "Waitress" },
    { name: "Theresa Webb", role: "Dishwasher" },
    { name: "Ronald Richards", role: "Chef" },
  ],
  shift2: [
    { name: "Leslie Alexander", role: "Admin" },
    { name: "Floyd Miles", role: "Cashier" },
    { name: "Kristin Watson", role: "Chef" },
    { name: "Devon Lane", role: "Waitress" },
    { name: "Marvin McKinney", role: "Dishwasher" },
    { name: "Jerome Bell", role: "Chef" },
  ],
};
export default EmployeeData;
